export const COPILOT_QUOTA_API = 'https://caira-api-stage-cvx.azurewebsites.net/api/copilot/quota';

export const DISCOVER_TAB_ENDPOINTS = {
  CLUSTER: {
    GET: ``,
  },
  APPLICATION: {
    GET: ``,
  },
  CLUSTER_DETAILS: {
    GET: ``,
  },
};
const API_PREFIX = '/api';

export const API_URLS = {
	copilotQuota: `${API_PREFIX}/copilot/quota`,
	applicationDetails: (appId: string) =>
		`${API_PREFIX}/application/${encodeURIComponent(appId)}/details`,
  applicationRepositories: (appId: string) =>
    `${API_PREFIX}/applications/${encodeURIComponent(appId)}/repositories`,
	generatedDocuments: (generationId: string) =>
		`${API_PREFIX}/doc-generations/${encodeURIComponent(generationId)}/documents`,
  documentGenerationStatus: (generationId: string) =>
    `${API_PREFIX}/doc-generations/${encodeURIComponent(generationId)}`,
  documentGenerationContent: (generationId: string) =>
    `${API_PREFIX}/doc-generations/${encodeURIComponent(generationId)}/content`,
  regenerateDocuments: (generationId: string) =>
    `${API_PREFIX}/doc-generations/${encodeURIComponent(generationId)}/regenerate`,
  downloadDocumentReports: (generationId: string) =>
    `${API_PREFIX}/doc-generations/${encodeURIComponent(generationId)}/reports/download`,
	documentGenerationVersions: (appId: string) =>
		`${API_PREFIX}/doc-generations/versions/${encodeURIComponent(appId)}`,
  submitDocumentGeneration: `${API_PREFIX}/doc-generations`,
  submitComparisonMatrix: `${API_PREFIX}/v2/comparison-matrices`,
  comparisonMatrixStatus: (runId: string) =>
    `${API_PREFIX}/v2/comparison-matrices/${encodeURIComponent(runId)}`,
  comparisonMatrixReport: (runId: string) =>
    `${API_PREFIX}/comparison-matrices/${encodeURIComponent(runId)}/report`,
  downloadComparisonMatrixReports: (runId: string) =>
    `${API_PREFIX}/comparison-matrices/${encodeURIComponent(runId)}/reports/download`,
} as const;
